export default __webpack_public_path__ + "static/media/slovakia.02a5bb72.webp";